module.exports = __webpack_public_path__ + "static/img/P2_gray.829c1bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/P2_gray.png
// module id = UlMs
// module chunks = 0